import api from './api'

// Logs de ManagedDevice (syslog remoto via VPN). Página mais recente primeiro;
// nextBeforeId = cursor para a página seguinte (mais antiga), null = fim.
export const managedDeviceLogsApi = {
  getByDevice: async (deviceId, params = {}) => {
    const response = await api.get(`/managed-devices/${deviceId}/logs`, { params })
    return response.data
  },

  getByTenant: async (tenantId, params = {}) => {
    const response = await api.get(`/tenants/${tenantId}/managed-device-logs`, { params })
    return response.data
  },
}
